var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Twitter","d":"M44.848,19.54A12.5,12.5,0,0,0,57.462,6.926v-.6a9.765,9.765,0,0,0,2.162-2.283,9.973,9.973,0,0,1-2.523.721,4.674,4.674,0,0,0,1.922-2.4,11.019,11.019,0,0,1-2.763,1.081A4.29,4.29,0,0,0,53.017,2a4.514,4.514,0,0,0-4.445,4.445,2.342,2.342,0,0,0,.12.961,12.421,12.421,0,0,1-9.13-4.685A4.6,4.6,0,0,0,38.961,5a4.773,4.773,0,0,0,1.922,3.724,4.05,4.05,0,0,1-2.042-.6h0a4.391,4.391,0,0,0,3.6,4.325,3.7,3.7,0,0,1-1.2.12,2.044,2.044,0,0,1-.841-.12,4.551,4.551,0,0,0,4.2,3.124A9.07,9.07,0,0,1,39.081,17.5,3.326,3.326,0,0,1,38,17.377a11.339,11.339,0,0,0,6.848,2.162","transform":"translate(-38 -2)","fillRule":"evenodd"}));
}

Twitter.defaultProps = {"width":"21.624","height":"17.54","viewBox":"0 0 21.624 17.54"};

module.exports = Twitter;

Twitter.default = Twitter;
